import { TableHead as NovaTableHeadBase, TableHeadProps as NovaTableHeadProps } from '@fme-nova/components'
import { default as MuiTableHeadBase, TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'

const MuiTableHead = styled(MuiTableHeadBase)`
  & .MuiTableCell-root {
    font-weight: 700;
    line-height: 24px;
    border-bottom: 2px solid ${COLORS.divider};
  }
`

export const TableHeader = createComponentWrapperWithRef<MuiTableHeadProps | NovaTableHeadProps>(
  {
    mui: MuiTableHead,
    nova: NovaTableHeadBase,
  },
  'TableHeader',
)
